import { render, staticRenderFns } from "./SkillAlternative.vue?vue&type=template&id=78302296&scoped=true&"
import script from "./SkillAlternative.vue?vue&type=script&lang=ts&"
export * from "./SkillAlternative.vue?vue&type=script&lang=ts&"
import style0 from "./SkillAlternative.vue?vue&type=style&index=0&id=78302296&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78302296",
  null
  
)

export default component.exports